import { ShieldX } from 'lucide-react'
import { Link } from 'react-router'
import { authenticatedHomePath } from '@/config/env'
import { homePathFor } from '../domain/authorization'
import { useAuth } from './useAuth'

export function ForbiddenPage() {
  const { session, signOut } = useAuth()
  return (
    <main className="authorization-state">
      <div>
        <ShieldX aria-hidden="true" />
        <span className="auth-page__eyebrow">Accès refusé · 403</span>
        <h1>Cette section ne fait pas partie de vos accès.</h1>
        <p>
          Votre session est active pour {session?.organizationName}, mais la permission requise n’est pas
          accordée.
        </p>
        <div className="authorization-state__actions">
          <Link to={homePathFor(session, authenticatedHomePath)}>
            {session && homePathFor(session, authenticatedHomePath) !== authenticatedHomePath
              ? 'Retour à mes balises'
              : 'Retour à l’accueil'}
          </Link>
          <button type="button" onClick={() => void signOut()}>
            Changer de compte
          </button>
        </div>
      </div>
    </main>
  )
}
